import React from "react";
import Carousel from "../carousel/Carousel";
import img1 from "../../Images/Barberia.jpeg";
import img2 from "../../Images/img1.jpeg";
import img3 from "../../Images/img2.jpeg";
import img4 from "../../Images/img3.jpeg";
import "./about.scss";
export default function About() {
  return (
    <div className="about" id="About">
      <Carousel images={[img1, img2, img3, img4]} className="carousel"></Carousel>
      <div className="info">
        <h2>Bienvenidos a Rase BarberShop</h2>
        <p>
          Barbero Franco Escorcia cuenta con más de 10 años de experiencia
          siendo barbero
        </p>
      </div>
    </div>
  );
}
